export const COMPANY_INFO = `
サイト名：Aish5X

運営会社：株式会社アフロフェアーインターネット

事業内容：AIを活用した商品検索・比較支援サービスの提供

所在地：日本

連絡先：contact@aish5x.com
※ お問い合わせは上記メールアドレスまでご連絡ください。
`;

export const TERMS_TEXT = `
本利用規約（以下「本規約」）は、Aish5X（以下「当サイト」）が提供するサービスの利用条件を定めるものです。ユーザーの皆さまには、本規約に同意いただいた上で当サイトをご利用いただきます。

第1条（サービス内容）

当サイトは、AIを用いてユーザーの条件に基づく商品検索・比較を支援する情報提供サービスです。
当サイトは、商品の販売を行うものではありません。

第2条（外部サイトについて）

当サイトからリンクやバナーなどによって、Amazon、楽天市場、Yahoo!ショッピング等の外部サイトへ移動することがあります。
移動先サイトで提供される商品、サービス、情報等については、各運営者の責任により提供されるものであり、当サイトは一切の責任を負いません。

第3条（アフィリエイトプログラムについて）

当サイトは、Amazon.co.jpを宣伝しリンクすることによって紹介料を獲得できる
Amazonアソシエイト・プログラムの参加者です。

また、当サイトは、その他のアフィリエイトプログラムを利用する場合があります。

第4条（免責事項）

当サイトに掲載する情報については、正確性・最新性の確保に努めていますが、その内容を保証するものではありません。
商品価格、在庫状況、仕様等は、必ず各ECサイトにてご確認ください。

当サイトの利用により生じた損害について、当サイトは一切の責任を負いません。

第5条（規約の変更）

本規約は、必要に応じて予告なく変更されることがあります。

`;

export const PRIVACY_POLICY_TEXT = `
Aish5X（以下「当サイト」）は、ユーザーの個人情報の保護を重要な責務と考え、以下のとおりプライバシーポリシーを定めます。

【個人情報の取得について】
当サイトでは、お問い合わせの際に、メールアドレス等の個人情報をご入力いただく場合があります。

【個人情報の利用目的】
取得した個人情報は、以下の目的で利用します。

【お問い合わせへの対応】
サービス改善および品質向上のための分析

【個人情報の第三者提供】
法令に基づく場合を除き、本人の同意なく第三者に個人情報を提供することはありません。

【広告配信について】
当サイトは、第三者配信の広告サービス（Amazonアソシエイト・プログラム等）を利用しています。
広告配信事業者は、ユーザーの興味に応じた広告を表示するため、Cookieを使用することがあります。

【アクセス解析について】
当サイトでは、サービス向上を目的としてアクセス解析ツールを利用する場合があります。
取得されるデータは匿名であり、個人を特定するものではありません。

【プライバシーポリシーの変更】
本ポリシーの内容は、必要に応じて変更されることがあります。

`;
